import { render, staticRenderFns } from "./title-wrap.vue?vue&type=template&id=2110b358&scoped=true&"
import script from "./title-wrap.vue?vue&type=script&lang=js&"
export * from "./title-wrap.vue?vue&type=script&lang=js&"
import style0 from "./title-wrap.vue?vue&type=style&index=0&id=2110b358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110b358",
  null
  
)

export default component.exports